import {DRAWER_OPEN, DRAWER_CLOSE} from 'app/redux/constants/actionTypes';

const drawerToggle = newState => {
  switch (newState) {
    case 'open' || true:
      return {
        type: DRAWER_OPEN
      }
    case 'close' || false:
      return {
        type: DRAWER_CLOSE
      }
    default:
      return {type: DRAWER_CLOSE};
  }
};

export default drawerToggle;